import { useContent } from '@/context/ContentContext';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';

export default function Faq() {
  const { t } = useContent();
  if (!t) return null;
  return (
    <section id="faq" data-testid="faq-section" className="relative py-20 sm:py-24 md:py-40 bg-paper-2 border-y border-[var(--line)]">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 md:px-10 grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-16">
        <div className="md:col-span-4">
          <div className="font-mono text-[10px] uppercase tracking-[0.28em] sm:tracking-[0.3em] text-ember mb-4 sm:mb-6">
            § Chapter V · Questions
          </div>
          <h2 className="font-serif text-4xl sm:text-5xl md:text-6xl leading-[0.95] tracking-tight">
            {t.faq.title}
          </h2>
        </div>
        <div className="md:col-span-8">
          <Accordion type="single" collapsible className="w-full">
            {t.faq.items.map((it, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="border-t border-[var(--line)] last:border-b"
              >
                <AccordionTrigger
                  className="py-6 sm:py-8 hover:no-underline text-left group"
                  data-testid={`faq-trigger-${i}`}
                >
                  <div className="flex items-start gap-4 sm:gap-6 w-full pr-4 sm:pr-6">
                    <span className="font-mono text-[10px] uppercase tracking-[0.24em] sm:tracking-[0.28em] text-ember pt-1 flex-shrink-0">
                      0{i + 1}
                    </span>
                    <span className="font-mono text-sm sm:text-base md:text-lg text-ink group-hover:text-ember transition-colors leading-snug">
                      {it.q}
                    </span>
                  </div>
                </AccordionTrigger>
                <AccordionContent className="pl-[calc(1.25rem+1rem)] sm:pl-[calc(1.75rem+1.5rem)] pr-4 sm:pr-6 pb-6 sm:pb-8 font-serif italic text-base sm:text-lg md:text-xl leading-relaxed text-ink-dim">
                  {it.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
